/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartitionValueFilter } from './partitionValueFilter';


export interface BusinessObjectDataAvailabilityRequest { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of a Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The Business Object Format Version for a previously registered Business Object Format
     */
    businessObjectFormatVersion?: number;
    /**
     * A container for Partition Value Filters
     */
    partitionValueFilters?: Array<PartitionValueFilter>;
    partitionValueFilter?: PartitionValueFilter;
    /**
     * The numeric version of a Business Object Data
     */
    businessObjectDataVersion?: number;
    /**
     * An optional Business Object Data Status value for available Business Object Data. Accepted values are VALID and all                   pre-registration status values, such as PROCESSING, UPLOADING, and PENDING_VALID. Default value is VALID. The request cannot                   contain both businessObjectDataVersion and businessObjectDataStatus values                
     */
    businessObjectDataStatus?: string;
    /**
     * A container for Storage Names to include when checking for Business Object Data availability
     */
    storageNames?: Array<string>;
    /**
     * Name of an existing storage known to the System. Required when StorageName is present
     */
    storageName?: string;
    /**
     * Specifies to perform an exhaustive search to return availability for ALL registered sub-partitions (registered as individual                   business object data instances) except for the ones with \"DELETED\" status. This parameter has no impact when business object data version is                   specified. Default value is false, which means that availability ignores any \"not available\" registered sub-partitions when it finds at least                   one \"VALID\" registered sub-partitions for a requested business object data partition value                
     */
    includeAllRegisteredSubPartitions?: boolean;
}
